module.exports = __webpack_public_path__ + "static/tow-truck4-523fdc1f88ce9034bc127d63351aa020.jpg";